import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/noviceGuide/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/noviceGuide'
  }
]
